import React from 'react';
import createReactClass from 'create-react-class';

var SparksChart = createReactClass({
  getDefaultProps(){
    return {
      colorClassName: 'txt-color-blue',
      values: '',
      title: 'Title',
      summary: 'Summary',
      showOnlyTitle: false
    };
  },

  render() {
    return (
      <li className="sparks-info">
        <h5> {this.props.title} <span className={this.props.colorClassName}>{this.props.summary}</span></h5>
        {
            this.props.showOnlyTitle ?
            (<span></span>) :
            (
              <div className={`sparkline ${this.props.colorClassName} hidden-mobile hidden-md hidden-sm`}>
                {this.props.values}
              </div>
            )
        }
      </li>
    );
  }
});

export default SparksChart;



// WEBPACK FOOTER //
// ./src/components/common/Diagrams/SparksChart.js